/* ============================== */
/* assets/cart.js — stable build  */
/* ============================== */
if (window.__CART_JS_LOADED__) {
  console.warn('[cart.js] loaded twice — skipping second init');
} else {
  window.__CART_JS_LOADED__ = true;

  /* ---------- Utilities ---------- */
function debounce(fn, t){ let id; return (...a)=>{ clearTimeout(id); id=setTimeout(()=>fn.apply(this,a), t); }; }
function fetchConfig(){ return { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, credentials:'same-origin' }; }
const CART_DEBUG = true;
function dbg(...args){ if (CART_DEBUG && window.console && console.debug) console.debug('[cart.js]', ...args); }


/* ---------- Trace (ordered steps) ---------- */
const CART_TRACE = true;
window.CART_TRACE_PLUSMINUS = true;
window.CART_TRACE_UPDATES = true;
window.CART_TRACE_REFRESH = true;
window.CART_TRACE_MILESTONES = true;
const t0 = performance.now();
function trace(step, data = {}, source = 'cart.js') {
  if (!CART_TRACE) return;
  const t = (performance.now() - t0).toFixed(1);
  try {
    console.log(`[TRACE ${source}] ${step} @+${t}ms`, data);
  } catch (_) {}
}

/* ---------- Cached cart fetch ---------- */
let CART_LAST_JSON = null, CART_LAST_TS = 0;
async function getCartJSON(force = false) {
  const now = Date.now();
  if (!force && CART_LAST_JSON && now - CART_LAST_TS < 300) return CART_LAST_JSON;

  __cartFetchPromise = fetch(`/cart.js?ts=${Date.now()}`, { cache: 'no-store', credentials: 'same-origin' })
    .then(r => r.json())
    .finally(() => setTimeout(() => (__cartFetchPromise = null), 300));

  CART_LAST_JSON = await __cartFetchPromise;
  CART_LAST_TS = now;
  return CART_LAST_JSON;
}

/* ---------- Post-render pipeline ---------- */
function runPostRenderHooks(cart, origin = 'cart.js') {
  const idle = window.requestIdleCallback || (fn => setTimeout(fn, 40));
  idle(() => {
    try { window.applyInventoryGuards?.(document); } catch {}
    try { window.__updateMilestones?.(cart); syncMilestoneRewards?.(cart); window.reorderMilestoneDetails?.();
      idle(() => {
      try {
        window.reorderMilestoneDetails?.();
        window.reorderMilestoneSteps?.();
      } catch (_) {}
    });

     } catch {}
    idle(() => {
      try { window.syncShippingProtectionToggle?.(cart); } catch {}
      try { window.guardDrawerQuickAddButtons?.(); } catch {}
      try { window.reInitCartSwiper?.('post-render'); } catch {}
    });
  });
  applyGwpLinesAfterRender();
}
window.__MILESTONE_REFRESH_LOCK__ = false;
window.__MILESTONE_ANCHOR__ = document.querySelector('.milestones-bar') || null;
if (window.__MILESTONE_ANCHOR__) {
  window.__MILESTONE_ANCHOR__.dataset.milestoneAnchor = "true";
}

function applyGwpLinesAfterRender(isRewardSync = false) {
  const rewardEls = document.querySelectorAll('.milestone-detail[data-variant-id]');
  const rewardIds = Array.from(rewardEls)
    .map(el => parseInt(el.dataset.variantId, 10))
    .filter(id => !isNaN(id) && id > 0);

  if (!rewardIds.length) return;

  const reapply = () => {
    try {
      document.querySelectorAll('tr[data-variant-id]').forEach(el => {
        const vid = parseInt(el.dataset.variantId, 10);
        const isGwp = rewardIds.includes(vid);
        el.classList.toggle('gwp-line', isGwp);
        if (isGwp) {
          const details = el.querySelector('.cart-item__details');
          if (details && !details.querySelector('.gwp-notice')) {
            const tag = document.createElement('div');
            tag.className = 'gwp-notice';
            tag.textContent = '1 Per Order';
            details.appendChild(tag);
          }
        }
      });
      console.log(`[CartDrawer] 🧩 GWP-line ensured (event)`, rewardIds);
    } catch (err) {
      console.warn('[CartDrawer] GWP ensure failed', err);
    }
  };

  // 🕒 Instead of fixed delay, wait until cart rows are visible post-render
  const observer = new MutationObserver((mutations, obs) => {
    const newItems = document.querySelectorAll('cart-drawer-items tr[data-variant-id]');
    if (newItems.length) {
      obs.disconnect();
      setTimeout(reapply, isRewardSync ? 250 : 50); // small natural delay
    }
  });

  observer.observe(document.querySelector('cart-drawer-items') || document.body, {
    childList: true,
    subtree: true
  });
}




/* ---------- Strings shim (prevents validate crashes) ---------- */
window.quickOrderListStrings = Object.assign({
  min_error: 'You must add at least [min].',
  max_error: 'Only [max] available.',
  step_error: 'Please add in multiples of [step].',
  quantityError: 'Quantity updated to [quantity].',
  error: 'Something went wrong.'
}, window.quickOrderListStrings || {});

window.cartStrings = Object.assign({
  min_error: 'You must add at least {min}.',
  max_error: 'Only {max} available.',
  step_error: 'Please add in multiples of {step}.',
  quantityError: 'Quantity updated to [quantity].',
  error: 'Something went wrong.'
}, window.cartStrings || {});


function roundMoney(v) {
  return Math.round(v * 100) / 100;
}

/* ========================= */
/*  Milestone heading fixer  */
/* ========================= */
function normalizeMilestoneDescriptions(cartTotal) {
  document.querySelectorAll('.milestone-detail').forEach(detail => {
    const heading = detail.dataset.heading || '';
    const threshold = parseFloat(detail.dataset.threshold || '0');
    const descEl = detail.querySelector('.milestone-description');
    if (!descEl) return;

    const remaining = threshold - cartTotal;

    if (remaining > 0) {
      descEl.innerHTML = `
        You're $<span class="left-over">${remaining.toFixed(2)}</span>
        away from ${heading}
      `;
    } else {
      descEl.innerHTML = `
        You've unlocked ${heading}!
      `;
    }
  });
}

/* ====================================================== */
/* MILESTONES CONTROLLER — single visible milestone + GWP */
/* ====================================================== */
(function () {
  function updateMilestones(cart) {
    normalizeMilestoneDescriptions(cart.total_price / 100);
    const milestoneEls = document.querySelectorAll('.milestone-detail');
    if (!milestoneEls.length) {
      try { console.debug('[milestones] none found'); } catch (_) {}
      return;
    }
    const cartTotal = (cart && cart.total_price ? cart.total_price / 100 : 0);
    const milestones = Array.from(milestoneEls).map((el) => {
    const threshold = parseFloat(el.getAttribute('data-threshold')) || 0;
    const idx = parseInt(
      [...el.classList]
        .find(cls => /^milestone-\d+$/.test(cls))
        ?.split('-')[1],
      10
    ) || 0;

    const stepEl = document.querySelector(`.milestone-step.milestone-${idx}`);
    const stepIcon = stepEl?.querySelector('.milestone-icon') || null;
    return { el, threshold, idx, stepEl, stepIcon };
  });
    //trace('M_LIST', milestones.map(m => ({ idx: m.idx, threshold: m.threshold,classes: m.el.className})), 'milestones');
    window.__lastUnlockedMilestone = window.__lastUnlockedMilestone || 0;
    milestones.forEach((m) => {
      const nowAchieved = cartTotal >= m.threshold;
      if (nowAchieved) {
        m.el.classList.add('milestone-achieved');
        m.el.classList.remove('milestone-locked');
        if (m.stepIcon) {
          m.stepIcon.classList.add('milestone-achieved');
          m.stepIcon.classList.remove('milestone-locked');
        }
      } else {
        m.el.classList.add('milestone-locked');
        m.el.classList.remove('milestone-achieved');
        if (m.stepIcon) {
          m.stepIcon.classList.add('milestone-locked');
          m.stepIcon.classList.remove('milestone-achieved');
        }
      }
    });
    window.reorderMilestoneDetails?.();
    window.reorderMilestoneSteps?.();
    const highestNow = milestones.reduce(
      (max, m) => (cartTotal >= m.threshold && m.idx > max ? m.idx : max),
      0
    );

      milestones.forEach(m => {
        const wasAchieved = (window.__lastUnlockedMilestone >= m.idx);
        const nowAchieved = (cartTotal >= m.threshold);
        if (!wasAchieved && nowAchieved && m.stepIcon) {
          m.stepIcon.classList.add('flip');
          m.stepIcon.addEventListener(
            'animationend',
            () => m.stepIcon.classList.remove('flip'),
            { once: true }
          );
        }
      });
    window.__lastUnlockedMilestone = highestNow;

    let visible;
    const sorted = [...milestones].sort((a, b) => a.threshold - b.threshold);
    const unlocked = sorted.filter(m => cartTotal >= m.threshold);
    //trace('M_UNLOCKED', unlocked.map(m => ({
    // idx: m.idx, threshold: m.threshold
    //})), 'milestones');
    if (unlocked.length > 0) {
      const highestUnlocked = unlocked[unlocked.length - 1];
      const nextIndex = sorted.indexOf(highestUnlocked) + 1;
      visible = sorted[nextIndex] || highestUnlocked; // if no next → show last
    } else {
      visible = sorted.find(m => cartTotal < m.threshold) || sorted[0];
    }

    milestones.forEach(m => m.el.classList.toggle('is-visible', m === visible));
   

    //trace('M_VISIBLE', {idx: visible?.idx, threshold: visible?.threshold, class: visible?.el?.className}, 'milestones');
    const stepEl = document.querySelector(`.milestone-step.milestone-${visible.idx}`);
    const detailEl = visible.el;
    if (stepEl && detailEl) {
      const maxThreshold = Math.max(...milestones.map(m => m.threshold), 0) || 1;
      let pct = (visible.threshold / maxThreshold) * 100;
      const EDGE_PAD = 5;
      pct = Math.min(100 - EDGE_PAD, Math.max(EDGE_PAD, pct));
      detailEl.style.setProperty('--connector-left', `${pct}%`);
    }
    try {
      const steps = Array.from(document.querySelectorAll('.milestone-step'))
        .map(stepEl => {
          const idx = stepEl.className.match(/milestone-(\d+)/)?.[1];
          const threshold = parseFloat(
            document.querySelector(`.milestone-detail.milestone-${idx}`)?.dataset.threshold || '0'
          ) || 0;
          return { stepEl, threshold, idx };
        })
        .filter(m => m.threshold > 0);

      if (steps.length) {
  const maxThreshold = Math.max(...steps.map(m => m.threshold));
  steps.forEach((m, index) => {
    const isLast = index === steps.length - 1;
    let pct = (m.threshold / maxThreshold) * 100;
    const EDGE_PAD = 10;
    const PIXEL_OFFSET = -10;
    pct = Math.max(EDGE_PAD, pct);
    if (isLast) {
      pct = Math.min(100 - (EDGE_PAD * -1), pct); 
    } else {
      pct = Math.min(100 - EDGE_PAD, pct);
    }

    const finalLeft = `calc(${pct}% + ${PIXEL_OFFSET}px)`;
    m.stepEl.style.position = 'absolute';
    m.stepEl.style.left = finalLeft;
    m.stepEl.style.transform = 'translateX(-50%)';
    m.stepEl.style.setProperty('--milestone-left', finalLeft);
    const detailEl = document.querySelector(`.milestone-detail.milestone-${m.idx}`);
    if (detailEl) {
      detailEl.style.setProperty('--milestone-left', finalLeft);
    }
  });}
    } catch (e) {
      console.warn('[milestones] step positioning failed', e);
    }

    milestones.forEach((m) => {
      m.el.style.display = (m === visible) ? 'flex' : 'none';
    });

    const thresholds = milestones.map(m => m.threshold).sort((a, b) => a - b);
    const maxThreshold = thresholds[thresholds.length - 1] || 1;
    let pct = Math.max(0, Math.min(100, Math.round((cartTotal / maxThreshold) * 100)));
    //trace('M_PROGRESS', { pct, maxThreshold }, 'milestones');
    const progressRoot = document.querySelector('.progress-bar-wrapper');
    if (progressRoot) {
      const fill = progressRoot.querySelector('.progress-bar-fill');
      if (fill) fill.style.width = `${pct}%`;
      const label = progressRoot.querySelector('[data-progress-label]');
      if (label) label.textContent = `${pct}%`;
    }

    try {
      const rewardEls = document.querySelectorAll('.milestone-detail[data-variant-id]');
      const cartVariantIds = cart.items.map(item => item.variant_id);
      rewardEls.forEach(el => {
        const variantId = parseInt(el.dataset.variantId, 10);
        const unlocked = cartVariantIds.includes(variantId);
        el.classList.toggle('milestone-achieved', unlocked);
        el.classList.toggle('milestone-locked', !unlocked);
      });
    } catch (e) {
      console.warn('[milestones] reward milestone update failed', e);
    }

    requestAnimationFrame(() => {
        setTimeout(() => {
          try {
            const milestoneEls = document.querySelectorAll('.milestone-detail');
            const cartTotal = cart.total_price / 100;

            milestoneEls.forEach(detail => {
              const threshold = parseFloat(detail.dataset.threshold || '0');
              const heading = detail.dataset.heading || detail.querySelector('h3')?.innerText || '';
              const desc = detail.querySelector('.milestone-description');
              if (!desc) return;

              const remaining = threshold - cartTotal;

              if (remaining > 0) {
                desc.innerHTML = `
                  You're $<span class="left-over">${remaining.toFixed(2)}</span>
                  away from ${heading}
                `;
              } else {
                desc.innerHTML = `
                  You've unlocked ${heading}!
                `;
              }
            });
          } catch(e) {
            console.warn("[Milestones] deferred desc update failed", e);
          }
        }, 80); // allow reorder + refresh to finish
      });


  }

  window.__updateMilestones = updateMilestones;
  window.reorderMilestoneDetails = function reorderMilestoneDetails() {
    try {
      const wrap = document.querySelector('.milestone-details');
      if (!wrap) return;
      const items = Array.from(wrap.querySelectorAll('.milestone-detail'));
      if (!items.length) return;
      items.sort((a, b) => {
        const ta = parseFloat(a.dataset.threshold) || 0;
        const tb = parseFloat(b.dataset.threshold) || 0;
        return ta - tb;
      });
      items.forEach(el => wrap.appendChild(el));
      //trace('M_REORDER_END', {}, 'milestones');
    } catch (err) {
      //console.warn('[Milestones] reorder failed', err);
    }
  };
 window.reorderMilestoneSteps = function reorderMilestoneSteps() {
  const wrap = document.querySelector('.milestone-steps');
  if (!wrap) return;
  const items = Array.from(wrap.querySelectorAll('.milestone-step'));
  items.sort((a, b) => {
    const idxA = a.className.match(/milestone-(\d+)/)?.[1];
    const idxB = b.className.match(/milestone-(\d+)/)?.[1];
    const elA = document.querySelector(`.milestone-detail.milestone-${idxA}`);
    const elB = document.querySelector(`.milestone-detail.milestone-${idxB}`);
    const ta = parseFloat(elA?.dataset.threshold) || 0;
    const tb = parseFloat(elB?.dataset.threshold) || 0;
    return ta - tb;
  });
  items.forEach(el => wrap.appendChild(el));
};

  // --- Page load milestone + GWP bootstrap ---
  getCartJSON()
  .then(updateMilestones)
  .catch(() => {});
  const initGwpOnReady = () => {
    const drawerItems = document.querySelector('cart-drawer-items');
    const milestonesReady = document.querySelector('.milestone-detail[data-variant-id]');
    if (!drawerItems || !milestonesReady) {
      requestAnimationFrame(initGwpOnReady);
      return;
    }
    getCartJSON()
  .then(cart => {
    const rewardEls = document.querySelectorAll('.milestone-detail[data-variant-id]');
    const rewardIds = Array.from(rewardEls)
      .map(el => parseInt(el.dataset.variantId, 10))
      .filter(id => !isNaN(id));
    cart.items.forEach(item => {
      if (rewardIds.includes(item.variant_id)) {
        const line = document.querySelector(`tr[data-variant-id="${item.variant_id}"]`);
        if (line) {
          line.classList.add('gwp-line');
          const details = line.querySelector('.cart-item__details');
          if (details && !details.querySelector('.gwp-notice')) {
            const tag = document.createElement('div');
            tag.className = 'gwp-notice';
            tag.textContent = '1 Per Order';
            details.appendChild(tag);
          }
        }
      }
    });
  })
  .catch(err => console.warn('[initGwpOnReady] failed', err));
  };
  initGwpOnReady();
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => {
      getCartJSON().then(updateMilestones).catch(() => {});
    });
  }
})();
let cartUpdateInflight = false;
function safeJSON(text) {
  try { return JSON.parse(text); }
  catch (err) {
    console.warn('[cart.js] JSON parse failed', { text });
    return null;
  }
}

//* ====================================================== */
/* Abuse Protection              */
/* ====================================================== */
function toggleCheckoutDisabled(state, label = null) {
  const buttons = document.querySelectorAll(
    '.cart__checkout-button, #CartDrawer .cart__checkout-button, #main-cart-footer .cart__checkout-button'
  );
  buttons.forEach(btn => {
    if (!btn) return;
    const span = btn.querySelector('span') || btn; // account for span-wrapped labels
    if (state) {
      btn.disabled = true;
      btn.classList.add('is-disabled');
      if (span && label) {
        if (!span.dataset.originalText) span.dataset.originalText = span.textContent;
        span.textContent = label;
      }
    } else {
      btn.disabled = false;
      btn.classList.remove('is-disabled');
      if (span && span.dataset.originalText) {
        span.textContent = span.dataset.originalText;
        delete span.dataset.originalText;
      }
    }
  });
}

/* ===========================================================
   🔍 CHECKOUT BUTTON DIAGNOSTICS — DEBUG VERSION
   =========================================================== */
(function(){
  const selectors = [
    '.cart__checkout-button',
    '#CartDrawer .cart__checkout-button',
    '#main-cart-footer .cart__checkout-button'
  ];
  const log = (...a) => console.log('%c[CHECKOUT-DEBUG]', 'color:#ff4d4d;font-weight:bold;', ...a);

  function findBlockers(btn) {
    const rect = btn.getBoundingClientRect();
    const el = document.elementFromPoint(rect.left + 10, rect.top + 10);
    return el && el !== btn ? el : null;
  }

  function bind(btn) {
    if (!btn || btn.__checkoutDebugBound) return;
    btn.__checkoutDebugBound = true;
    btn.addEventListener('click', function (e) {
      log('CLICK detected →', btn);
      const disabled = btn.disabled;
      const pe = getComputedStyle(btn).pointerEvents;
      const overlay = findBlockers(btn);
      log('• disabled?', disabled);
      log('• pointer-events:', pe);
      log('• overlay blocking pointer (elementFromPoint)?', overlay);
      if (overlay) {
        log('  → overlay tag:', overlay.tagName, overlay.className);
      }
      const lockout = document.querySelector('.password-lockout, .lockout-screen-active');
      log('• password-lockout visible?', !!(lockout && lockout.offsetParent !== null));
      const span = btn.querySelector('span');
      log('• label:', span?.textContent);
      if (e.defaultPrevented) log('🚫 Event default prevented');
    }, true);
  }

  function init() {
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(btn => bind(btn));
    });
  }

  // Run now + observe for new buttons (drawer refresh)
  init();
  const mo = new MutationObserver(() => init());
  mo.observe(document.body, { childList: true, subtree: true });
})();


/* ====================================================== */
/* Sync milestone rewards with cart (Trace Instrumented)  */
/* ====================================================== */
if (window.rewardSyncLock == null) window.rewardSyncLock = false;
async function syncMilestoneRewards(cart) {
 
  if (!cart || !cart.items) {
   return;
  }
if (window.rewardSyncLock) return;
  window.rewardSyncLock = true;
  toggleCheckoutDisabled(true, 'Updating…');
  const ALLOW_STACKING = window.__ALLOW_MILESTONE_STACKING__ === true;
  const cartTotal  = cart.total_price / 100;
  const presentIds = cart.items.map(it => it.variant_id);
  const rewardEls  = document.querySelectorAll('.milestone-detail[data-variant-id]');
  let madeChanges = false;

  try {
    for (const el of rewardEls) {
      const threshold = parseFloat(el.dataset.threshold) || 0;
      const variantId = parseInt(el.dataset.variantId, 10);
      if (!variantId) continue;
      const reached = cartTotal >= threshold;
      const inCart  = presentIds.includes(variantId);

      /* ---------------------------------------------------------
         HARD CAP: NEVER allow more than 1 of any reward variant
      --------------------------------------------------------- */
      if (inCart) {
        const item = cart.items.find(it => it.variant_id === variantId);
        if (item && item.quantity > 1) {
          madeChanges = true;
          await fetch(`/cart/change.js?ts=${Date.now()}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept':'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: 1
            })
          });
        }
      }
      
      /* -------- ADD REWARD -------- */
      if (reached && !inCart) {
        madeChanges = true;
        await fetch(`/cart/add.js?ts=${Date.now()}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        continue;
      }
      /* -------- REMOVE REWARD -------- */
      if (!reached && inCart) {
        madeChanges = true;
        const lineKey = cart.items.find(it => it.variant_id === variantId)?.key;
        if (lineKey) {
          await fetch(`/cart/change.js?ts=${Date.now()}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
          });
        }
        continue;
      }

      /* -------- NO STACKING: remove non-highest -------- */
      if (!ALLOW_STACKING) {
        const highestThreshold = Math.max(
          ...Array.from(rewardEls).map(el => parseFloat(el.dataset.threshold) || 0)
        );
        const isHighest = threshold === highestThreshold;
        if (!isHighest && inCart) {
          madeChanges = true;
          const lineKey = cart.items.find(it => it.variant_id === variantId)?.key;
          if (lineKey) {
            await fetch(`/cart/change.js?ts=${Date.now()}`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: lineKey, quantity: 0 })
            });
          }
        }
      }
    }

    /* -------- ONE refresh after all changes -------- */
    if (madeChanges) {
      await refreshDrawer();
      applyGwpLinesAfterRender(true);
    } else {
    }

  } catch (err) {
  } finally {
    toggleCheckoutDisabled(false);
     window.rewardSyncLock = false;
  }
}


/* ====================================================== */
/* Drawer section refresh (header/items/footer/ctas/empty) */
/* ====================================================== */
async function refreshDrawer() {
  //trace('RD:START', {}, 'refreshDrawer');
  if (window.CART_TRACE_REFRESH) {
  //console.log(`[TRACE refreshDrawer:START] time=${performance.now()}`);
  }
  if (!console.__cartRefreshTimerActive) {
    console.__cartRefreshTimerActive = true;
    console.time('[CartDrawer] refresh');
  }
  const url = '/?sections=cart-drawer';
  let html;
  try {
    const res = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    html = await res.json();
  } catch (err) {
    console.error('[CartDrawer] failed to fetch section', err);
    return;
  }
  const parser = window.__sharedDOMParser || (window.__sharedDOMParser = new DOMParser());
  const doc = parser.parseFromString(html['cart-drawer'], 'text/html');

  /* Header Updates */
  const srcHeader = doc.querySelector('.drawer__header');
  const dstHeader = document.querySelector('.drawer__header');
    if (srcHeader && dstHeader) {
      const incomingMilestones = srcHeader.querySelector('.milestones-bar');
      if (incomingMilestones) incomingMilestones.remove();
      dstHeader.replaceWith(srcHeader);
      const newHeader = document.querySelector('.drawer__header');
      const anchor = window.__MILESTONE_ANCHOR__;
      if (anchor && newHeader && !newHeader.contains(anchor)) {
        newHeader.appendChild(anchor);
      }
    }
    //trace('RD:HEADER_REPLACED', {}, 'refreshDrawer');

  /* ---------- Item Updates ---------- */
  const srcItems = doc.querySelector('cart-drawer-items');
  const dstItems = document.querySelector('cart-drawer-items');
  if (srcItems && dstItems) {
  try {
    const rewardIds = Array.from(
      document.querySelectorAll('.milestone-detail[data-variant-id]')
    )
      .map(el => parseInt(el.dataset.variantId, 10))
      .filter(id => !isNaN(id) && id > 0);
      rewardIds.forEach(id => {
      const line = srcItems.querySelector(`tr[data-variant-id="${id}"]`);
      if (!line) return;
      line.classList.add('gwp-line');
      const details = line.querySelector('.cart-item__details');
      if (details && !details.querySelector('.gwp-notice')) {
        const notice = document.createElement('span');
        notice.className = 'gwp-notice micro-text';
        notice.textContent = '1 Per Order';
        const qtyBlock = details.querySelector('.cart-item__quantity');
        if (qtyBlock) details.insertBefore(notice, qtyBlock);
        else details.appendChild(notice);
      }
    });
    //trace('RD:ITEMS_REPLACED', { rewardIds }, 'refreshDrawer');
    dstItems.replaceWith(srcItems);
  } catch (err) {
    console.warn('[CartDrawer] GWP pre-injection failed', err);
  }
  }

  /* Footer Updates */
    const srcFooter = doc.querySelector('.drawer__footer');
    const dstFooter = document.querySelector('.drawer__footer');

    if (srcFooter && dstFooter) dstFooter.replaceWith(srcFooter);

    /* ============================================================
      CHECKOUT FORM FIXES (Safari-safe + Shopify-complete)
      ============================================================ */
    {
      const form = document.querySelector('#CartDrawer-Form');
      if (form) {

        // 1️⃣ Ensure correct form method + action
        form.setAttribute('action', '/cart');
        form.setAttribute('method', 'post');

        // 2️⃣ Shopify requires this hidden input to trigger checkout
        if (!form.querySelector('input[name="checkout"]')) {
          console.warn('[CHECKOUT FIX] Missing checkout input — adding it.');
          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'checkout';
          hidden.value = 'Checkout';
          form.appendChild(hidden);
        }

        // 3️⃣ Safari workaround — prevents “invalid form control not focusable”
        form.setAttribute('novalidate', 'true');
      } else {
        console.warn('[CHECKOUT FIX] #CartDrawer-Form not found after footer replace');
      }
    }
  /* Empty Cart state */
  const srcEmpty = doc.querySelector('.drawer__inner-empty');
  const dstEmpty = document.querySelector('.drawer__inner-empty');
  if (srcEmpty && dstEmpty) dstEmpty.replaceWith(srcEmpty);
  else if (srcEmpty && !dstEmpty) {
    document.querySelector('#CartDrawer .drawer__inner')?.appendChild(srcEmpty);
  } else if (!srcEmpty && dstEmpty) {
    dstEmpty.remove();
  }

  /* Fetch Cart JSOn before HasItems */
  let cart;
  try {
    cart = await getCartJSON(true);
  } catch {}
  const drawer = document.querySelector('cart-drawer');
  const itemsWrap = document.querySelector('cart-drawer-items');
  const hasItems = !!(cart?.items?.length);
  //trace('RD:CART_READY', { hasItems, itemCount: cart?.items?.length }, 'refreshDrawer');
  drawer?.classList.toggle('is-empty', !hasItems);
  itemsWrap?.classList.toggle('is-empty', !hasItems);

  /* Milestone Set Up */
  try {
    if (typeof window.__updateMilestones === 'function') {
        requestAnimationFrame(() => {
            const checkReady = () => {
              const ms = document.querySelectorAll('.milestone-detail');
              if (!ms.length) {
                requestAnimationFrame(checkReady);
                return;
              }

              // Ensure data-heading always matches the h3 text
              ms.forEach(el => {
                const h3 = el.querySelector('h3');
                if (h3) el.dataset.heading = h3.textContent.trim();
              });

              // Now let updateMilestones handle remaining amount
              window.__updateMilestones(cart);
            };

            checkReady();
          });

    }
    try {
      requestAnimationFrame(() => {
        window.reorderMilestoneDetails?.();
        window.reorderMilestoneSteps?.();
      });
    } catch (e) {
      console.warn('[Milestones] final reorder failed', e);
    }
  } catch (err) {
    console.warn('[CartDrawer] milestone refresh failed', err);
  }

  /* FORCE REWARD SYNC (CORRECT POSITION) */
  //trace('RD:FORCED_REWARD_SYNC', {}, 'refreshDrawer');
  requestAnimationFrame(() => {
      setTimeout(() => {
      getCartJSON(true).then(c => {
        syncMilestoneRewards(c);
      });
    }, 180);
  });

  /* Collection Swiper */
  try {
  const collectionEl = document.querySelector('.cart-drawer__collection');
  if (collectionEl) {
    collectionEl.classList.toggle('hidden', !hasItems);
  }
  if (hasItems) {
    const inner = document.querySelector('#CartDrawer .drawer__inner');
    const existingCartView = inner?.querySelector('.cart-view');
    const fetchedCartView = doc.querySelector('.cart-view');
    if (!existingCartView && fetchedCartView) {
      inner?.appendChild(fetchedCartView);
    }
    if (typeof window.reInitCartSwiper === 'function') {
      requestAnimationFrame(() => window.reInitCartSwiper('empty-to-filled'));
    }
  }
  } catch (err) {}

  /* Shipping Protection */
  try {
    const spEl = document.getElementById('shipping-protection');
    if (!spEl) {
    } else {
      const vid   = spEl.dataset.variantId || null;
      const btn   = spEl.querySelector('.sp-toggle');
      const label = btn?.querySelector('.sp-toggle-text');
      if (vid) {
        if (sessionStorage.getItem('sp_auto_added') === 'true') {
          const cart = await getCartJSON(true);
          const hasSP = cart.items.some(it => String(it.variant_id) === String(vid));
          if (hasSP && btn) {
            btn.setAttribute('aria-pressed', 'true');
            btn.classList.remove('is-disabled');
            if (label) label.textContent = 'ON';
          }
          return;
        }
        const cart = await getCartJSON(true);
        const hasSP = cart.items.some(it => String(it.variant_id) === String(vid));
        const nonSPItems = cart.items.filter(it => String(it.variant_id) !== String(vid));
        const itemCount = nonSPItems.length;
        if (itemCount === 1 && !hasSP) {
          sessionStorage.setItem('sp_auto_added', 'true');
          await fetch(`/cart/add.js?ts=${Date.now()}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: vid, quantity: 1 })
          });
          if (btn) {
            btn.setAttribute('aria-pressed', 'true');
            btn.classList.remove('is-disabled');
            if (label) label.textContent = 'ON';
          }
          setTimeout(() => refreshDrawer().catch(()=>{}), 100);
        }
      } else {
      }
    }
  } catch (err) {
  }


  // --- Re-init components ---
  if (typeof applyInventoryGuards === 'function') applyInventoryGuards(document);
  if (typeof reInitCartSwiper === 'function') reInitCartSwiper('drawer-refresh');
  if (typeof guardDrawerQuickAddButtons === 'function') guardDrawerQuickAddButtons();
  if (typeof rebindCartDrawerAccordions === 'function') rebindCartDrawerAccordions();

  // --- Hooks & accordions ---
  try {
    if (typeof runPostRenderHooks === 'function') runPostRenderHooks(cart, 'refreshDrawer');
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate)
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'drawer-refresh', cartData: cart });
    syncShippingProtectionToggle();
    rebindCartDrawerAccordions();
    } catch (e) {}

    /* GWP Reapply Header */
  const headerWrap = document.querySelector('.cart-header-wrapper');
  if (headerWrap) {
  const headerObserver = new MutationObserver(() => {
    headerObserver.disconnect();

    setTimeout(() => {
      const drawerItems = document.querySelector('cart-drawer-items');
      const gwpNode = drawerItems?.querySelector('.gwp-notice');
      const gwpStillVisible = gwpNode && gwpNode.isConnected && drawerItems.contains(gwpNode);
      if (!gwpStillVisible) {
        try {
          applyGwpLinesAfterRender(true);
        } catch (err) {
          console.warn('[CartDrawer] GWP reapply failed', err);
        }
      } else {
      }
    }, 80); 
  });
  headerObserver.observe(headerWrap, { childList: true, subtree: false });
  }

  try {
    if (window.CART_TRACE_REFRESH) {
    //console.log(`[TRACE refreshDrawer:END] time=${performance.now()}`);
    }
    console.timeEnd('[CartDrawer] refresh');
    //trace('RD:END', {}, 'refreshDrawer');

  } catch (_) {}
  console.__cartRefreshTimerActive = false;
}



/* ---------- Smooth collapse (remove-row anim) ---------- */
function smoothCollapse(el) {
  if (!el) return;
  const h = el.getBoundingClientRect().height;
  el.style.boxSizing = 'border-box';
  el.style.height = h + 'px';
  el.style.transition = 'height .25s ease, opacity .25s ease, margin .25s ease, padding .25s ease';
  el.style.overflow = 'hidden';
  void el.offsetHeight;
  el.style.opacity = '0';
  el.style.marginTop = '0';
  el.style.marginBottom = '0';
  el.style.paddingTop = '0';
  el.style.paddingBottom = '0';
  el.style.height = '0px';
}

/* ---------- Remove button custom element ---------- */
(() => {
  // define the class only once, and attach it to window
  if (!window.CartRemoveButton) {
    window.CartRemoveButton = class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          event.preventDefault();
          const index = this.dataset.index;
          if (!index) return;
          const host =
            this.closest('cart-items') ||
            this.closest('cart-drawer-items');
          const row =
            document.getElementById(`CartItem-${index}`) ||
            document.getElementById(`CartDrawer-Item-${index}`) ||
            this.closest('tr.cart-item');
          if (row && document.body.contains(row)) {
            try { smoothCollapse(row); } catch (_) {}
          }
          setTimeout(() => {
            if (!host || typeof host.updateQuantity !== 'function') return;
            try { host.updateQuantity(index, 0, event, 'line'); } catch (_) {}
          }, 150);
        });
      }
    };
  }
  if (!customElements.get('cart-remove-button')) {
    customElements.define('cart-remove-button', window.CartRemoveButton);
  }
})();

/* tiny CSS for anim */
(() => {
  if (document.getElementById('cart-remove-anim-css')) return;
  const style = document.createElement('style');
  style.id = 'cart-remove-anim-css';
  style.textContent = `tr.cart-item { will-change: height, opacity, margin, padding; }`;
  document.head.appendChild(style);
})();


/* ====================================================== */
/* 🔍 PAGE LOAD REWARD CHECK */
/* ====================================================== */
document.addEventListener("DOMContentLoaded", async () => {

  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    syncMilestoneRewards(cart);

  } catch (err) {
  }
});


/* ===================================================================== */
/* INVENTORY GUARDS (enable/disable +/- based on DOM inventory limits)   */
/* ===================================================================== */
(function () {
function readMaxFromDOM(input) {
  const managed = String(input.dataset.variantManaged || '').toLowerCase() === 'true';
  const policy  = (input.dataset.variantPolicy || '').toLowerCase(); // deny|continue|''
  const rawMax  = parseInt(input.dataset.variantMax ?? '', 10);

  // Only cap if it’s managed, deny policy, and we actually have a number
  if (managed && policy !== 'continue') {
    if (Number.isFinite(rawMax)) return Math.max(0, rawMax);
    // No valid max exposed → don't cap
    return Infinity;
  }
  return Infinity;
}

  function toggleButtonsForInput(input) {
    const wrap  = input.closest('.quantity');
    if (!wrap) return;
    const minus = wrap.querySelector('button[name="minus"]');
    const plus  = wrap.querySelector('button[name="plus"]');
    const qty   = parseInt(input.value || input.getAttribute('value') || '1', 10) || 1;
    const max   = readMaxFromDOM(input);
    if (Number.isFinite(max)) input.max = String(max); else input.removeAttribute('max');
    const disableMinus = (qty <= 0);
    const disablePlus  = (qty >= max);
    if (minus) minus.disabled = disableMinus;
    if (plus)  plus.disabled  = disablePlus;
  }
  function guardOneInput(input) { toggleButtonsForInput(input); }

  window.applyInventoryGuards = function applyInventoryGuards(root = document) {
    const inputs = root.querySelectorAll('input.quantity__input[data-quantity-variant-id]');
    if (!inputs.length) return;
    inputs.forEach(guardOneInput);
    inputs.forEach((input) => {
      if (input.__hasGuardListener) return;
      input.addEventListener('input', () => guardOneInput(input), { passive: true });
      input.__hasGuardListener = true;
    });
  };

  const runNow = () => window.applyInventoryGuards(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runNow);
  else runNow();

  const observer = new MutationObserver(() => applyInventoryGuards(document));
observer.observe(document.body, { childList: true, subtree: false });

})();

/* ===================================================================== */
/* QUICK ADD — helpers + drawer swiper quick-add buttons                  */
/* ===================================================================== */
/* Cache */
const QA_INV_CACHE = { variant: new Map(), cart: null, cartAt: 0 };
/* Variant JSON */
async function fetchVariantJSON(variantId){
  if (QA_INV_CACHE.variant.has(variantId)) return QA_INV_CACHE.variant.get(variantId);
  const r = await fetch(`/variants/${variantId}.json`, { credentials:'same-origin' });
  if (!r.ok) return null;
  const j = await r.json();
  QA_INV_CACHE.variant.set(variantId, j?.variant || null);
  return j?.variant || null;
}

/* Cart JSON */
async function fetchCartJSON(force = false) {
  return getCartJSON(force);
}

function computeVariantMax(variant){
  if (!variant) return Infinity;
  const managed = !!variant.inventory_management;
  const deny    = (variant.inventory_policy === 'deny');
  const qty     = Number.isFinite(variant.inventory_quantity) ? Math.max(0, variant.inventory_quantity) : 0;
  return (managed && deny) ? qty : Infinity;
}
async function preflightAdd(variantId, requestedQty){
  const [variant, cart] = await Promise.all([ fetchVariantJSON(variantId), fetchCartJSON() ]);
  const max = computeVariantMax(variant);
  const inCart = (cart.items || []).reduce((sum, it) =>
    sum + (String(it.variant_id) === String(variantId) ? it.quantity : 0), 0);
  const remaining = Number.isFinite(max) ? Math.max(0, max - inCart) : Infinity;
  const allowed   = Number.isFinite(remaining) ? Math.min(requestedQty, remaining) : requestedQty;
  return { allowed, remaining, max, inCart };
}
function afterBlockedAdd(btn){
  if (btn) {
    btn.disabled = true;
    btn.classList.add('is-disabled');
    setTimeout(()=>{ btn.disabled = false; btn.classList.remove('is-disabled'); }, 400);
  }
}

/* Drawer open helper */
function openDrawer() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  try { drawer.open(); } catch(_) {}
  // Ensure visibility
  document.head.insertAdjacentHTML('beforeend', '<style>.drawer.active{visibility:visible}</style>');
}

/* ====================================================== */
/* Rebind interactive components after Drawer refresh     */
/* (with persistent open/close state)                     */
/* ====================================================== */
window.__cartCollectionOpen = sessionStorage.getItem('cart_collection_open') === 'true';
function rebindCartDrawerAccordions(retry = 0) {
  if (!document.querySelector('.cart-drawer__collection')) return;

  const header = document.querySelector('.cart-drawer__collection-header');
  const body = document.querySelector('.cart-drawer__collection-body');
  const wrap = document.querySelector('.cart-header-wrapper');

  if (!header || !body) {
    if (retry < 10) setTimeout(() => rebindCartDrawerAccordions(retry + 1), 150);
    return;
  }

  // 🔥 Clone header to reset all old listeners
  header.replaceWith(header.cloneNode(true));
  const newHeader = document.querySelector('.cart-drawer__collection-header');

  // 🔥 Apply persistent state
  const isOpen = window.__cartCollectionOpen === true;

  body.classList.toggle('open', isOpen);
  newHeader.classList.toggle('active', !isOpen);
  wrap?.classList.toggle('active', !isOpen);

  // 🔥 Persist on click
  newHeader.addEventListener('click', (e) => {
    e.preventDefault();
    const bodyNow = document.querySelector('.cart-drawer__collection-body');
    if (!bodyNow) return;

    const nowOpen = !bodyNow.classList.contains('open');

    bodyNow.classList.toggle('open', nowOpen);
    newHeader.classList.toggle('active', !nowOpen);
    wrap?.classList.toggle('active', !nowOpen);

    // 💾 Save state to sessionStorage
    window.__cartCollectionOpen = nowOpen;
    sessionStorage.setItem('cart_collection_open', nowOpen ? 'true' : 'false');
  });
}

window.rebindCartDrawerAccordions = rebindCartDrawerAccordions;



/* Guard/enabled-state for .quick-add-btns inside Drawer (e.g., swiper) */
window.guardDrawerQuickAddButtons = async function guardDrawerQuickAddButtons() {
  const btns = Array.from(document.querySelectorAll('#CartDrawer .quick-add-btn, cart-drawer .quick-add-btn'));
  if (!btns.length) return;

  const cart = await fetchCartJSON();
  const ids  = Array.from(new Set(btns.map(b => parseInt(b.getAttribute('data-variant-id') || '0', 10)).filter(Boolean)));

  const variants = await Promise.all(ids.map(id => fetchVariantJSON(id)));
  const vById = new Map(); variants.forEach(v => { if (v) vById.set(v.id, v); });

  function allowedFor(id, requested) {
    const v = vById.get(Number(id));
    if (!v) return requested;
    const managed = !!v.inventory_management;
    const deny    = v.inventory_policy === 'deny';
    const max     = (managed && deny && Number.isFinite(v.inventory_quantity))
      ? Math.max(0, v.inventory_quantity)
      : Infinity;
    const inCart = (cart.items || []).reduce((sum, it) =>
      sum + (String(it.variant_id) === String(id) ? it.quantity : 0), 0);
    const remaining = Number.isFinite(max) ? Math.max(0, max - inCart) : Infinity;
    return Number.isFinite(remaining) ? Math.min(requested, remaining) : requested;
  }

  btns.forEach(btn => {
    const id  = parseInt(btn.getAttribute('data-variant-id') || '0', 10);
    const req = parseInt(btn.getAttribute('data-quantity') || '1', 10) || 1;
    const allowed = allowedFor(id, req);
    if (!allowed || allowed <= 0) {
      btn.disabled = true; btn.classList.add('is-disabled'); btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.disabled = false; btn.classList.remove('is-disabled'); btn.removeAttribute('aria-disabled');
    }
  });
};

/* Click handler for Drawer Swiper Quick-Add buttons */
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('#CartDrawer .quick-add-btn, cart-drawer .quick-add-btn');
  if (!btn) return;
  e.preventDefault(); e.stopPropagation();
  if (!btn.getAttribute('type')) btn.setAttribute('type', 'button');

  const idStr = btn.getAttribute('data-variant-id');
  const id    = idStr ? parseInt(idStr, 10) : NaN;
  const req   = parseInt(btn.getAttribute('data-quantity') || '1', 10) || 1;
  if (!id || Number.isNaN(id)) return;

  let allowed = req;
  try { allowed = (await preflightAdd(id, req)).allowed; } catch (_) {}
  if (!allowed || allowed <= 0) { afterBlockedAdd(btn); return; }

  const labelEl = btn.querySelector('[data-label]') || btn.querySelector('.label') || btn;
  const prevTxt = (labelEl.textContent || '').trim();
  labelEl.textContent = 'Adding…';
  btn.disabled = true; btn.classList.add('is-loading');

  try {
    const r = await fetch(`/cart/add.js?ts=${Date.now()}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id, quantity: allowed }),
      credentials: 'same-origin'
    });
    if (!r.ok) throw await r.json();
    await refreshDrawer();
      try {
        const postCart = await getCartJSON(true);
        syncMilestoneRewards(postCart);
      } catch (err) {
      }
    openDrawer();
    try { if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'drawer-quick-add' }); } catch(_) {}
  } catch (err) {
    console.error('[DRAWER QUICK-ADD] failed', err);
    alert((err && err.description) || 'Could not add to cart.');
  } finally {
    labelEl.textContent = prevTxt || 'Add to Cart';
    btn.disabled = false;
    btn.classList.remove('is-loading');
  }
});

/* ===================================================================== */
/* CART ITEMS COMPONENT                                                  */
/* ===================================================================== */
class CartItems extends HTMLElement {
  constructor() {
    super();
    this._inflight = new Map(); 
      this._queued   = new Map();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => { this.onChange(event); }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener('change', debouncedOnChange.bind(this));

// ----- Global +/- handler (works for both <cart-items> and <cart-drawer-items>) -----
if (!window.__BIND_PM_CAPTURE__) {
  window.__BIND_PM_CAPTURE__ = true;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('button[name="plus"], button[name="minus"]');
    if (window.CART_TRACE_PLUSMINUS && btn) {
        console.log(`[TRACE ± CLICK] ${btn.name.toUpperCase()} clicked`, {
          index: btn.closest('.quantity')?.querySelector('.quantity__input')?.dataset.index,
          time: performance.now()
        });
      }

    if (!btn) return;
    const host = btn.closest('cart-items, cart-drawer-items');
    if (!host || typeof host.updateQuantity !== 'function') return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const wrap  = btn.closest('.quantity');
    const input = wrap && (wrap.querySelector('.quantity__input') || wrap.querySelector('input[name="updates[]"]'));
    if (!input) return;
    const line   = input.dataset.index;

      /* -------------------------------------------------------
    🔒 GWP HARD LOCK: Prevent qty > 1 OR qty = 0
    ------------------------------------------------------- */
      const row = btn.closest('tr.cart-item');
      if (row && row.classList.contains('gwp-line')) {

        // Always force quantity "1"
        input.value = "1";
        input.setAttribute("value", "1");

        // Prevent triggering updateQuantity()
        input.dataset.skipNextChange = "1";

        // Also disable +/- visually (optional but recommended)
        const minus = wrap.querySelector('button[name="minus"]');
        const plus  = wrap.querySelector('button[name="plus"]');
        if (minus) minus.disabled = true;
        if (plus)  plus.disabled  = true;

        console.log('[GWP] Quantity locked at 1');
        return; // 🚫 STOP the click handler entirely
      }
      /* ------------------------------------------------------- */


    const step   = parseInt(input.step || '1', 10) || 1;
    const min    = parseInt(input.min || input.dataset.min || '1', 10) || 1;
    const rawMax = parseInt(input.max ?? '', 10);
    const max    = Number.isFinite(rawMax) ? rawMax : Infinity;
    const curAttr = parseInt(input.getAttribute('value') || '0', 10);
    const curLive = parseInt(input.value || '0', 10);
    const current = Number.isFinite(curLive) && curLive > 0 ? curLive
                  : Number.isFinite(curAttr) && curAttr > 0 ? curAttr
                  : min;
    let next = current;
    if (btn.name === 'plus')  next = Math.min(current + step, max);
    else                      next = Math.max(0, current - step);

    input.value = String(next);
    input.setAttribute('value', String(next));
    input.dataset.skipNextChange = '1';
    host.updateQuantity(
      String(line),
      next,
      e,
      input.getAttribute('name'),
      input.dataset.quantityVariantId
    );
  }, true); 
  }
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') return;
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() { if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber(); }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (input) input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    if (event?.type === 'change' && event.target?.dataset?.skipNextChange === '1') {
      delete event.target.dataset.skipNextChange;
      return;
    }

    const tgt  = event.target;
    const idx  = tgt.dataset.index;
    const min  = parseInt(tgt.dataset.min || tgt.getAttribute('min') || '1', 10) || 1;
    const max  = parseInt(tgt.max ?? '', 10);
    const step = parseInt(tgt.step || '1', 10) || 1;

    let val = parseInt(tgt.value, 10);
    if (!Number.isFinite(val)) val = min;

    let message = '';
    if (val < min) message = window.quickOrderListStrings.min_error.replace('[min]', min);
    else if (Number.isFinite(max) && val > max) message = window.quickOrderListStrings.max_error.replace('[max]', max);
    else if ((val - min) % step !== 0) message = window.quickOrderListStrings.step_error.replace('[step]', step);

    if (message) {
      this.setValidity(event, idx, message);
    } else {
      tgt.setCustomValidity('');
      tgt.reportValidity();
      this.updateQuantity(
        idx,
        val,
        event,
        document.activeElement.getAttribute('name'),
        tgt.dataset.quantityVariantId
      );
    }
  }
  onChange(event) { this.validateQuantity(event); }
  onCartUpdate() {
    const isDrawer = this.tagName === 'CART-DRAWER-ITEMS';

    const url = isDrawer
      ? `${routes.cart_url}?section_id=cart-drawer`
      : `${routes.cart_url}?section_id=main-cart-items`;

    return fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');


        if (isDrawer) {
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          const rewardIds = Array.from(
            document.querySelectorAll('.milestone-detail[data-variant-id]')
          )
            .map((el) => parseInt(el.dataset.variantId, 10))
            .filter((id) => !isNaN(id) && id > 0);
          const srcItems = html.querySelector('cart-drawer-items');
          if (srcItems && rewardIds.length) {
            rewardIds.forEach((id) => {
              const line = srcItems.querySelector(`tr[data-variant-id="${id}"]`);
              if (!line) return;

              line.classList.add('gwp-line');
              const details = line.querySelector('.cart-item__details');
              if (details && !details.querySelector('.gwp-notice')) {
                const notice = document.createElement('span');
                notice.className = 'gwp-notice micro-text';
                notice.textContent = '1 Per Order';
                const qtyBlock = details.querySelector('.cart-item__quantity');
                if (qtyBlock) details.insertBefore(notice, qtyBlock);
                else details.appendChild(notice);
              }
            });
          }

          // ✅ 3️⃣ Replace only after pre-injection is done
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) targetElement.replaceWith(sourceElement);
          }

          // ✅ 4️⃣ Re-initialise cart behaviour
          if (typeof window.applyInventoryGuards === 'function')
            window.applyInventoryGuards(document);
          const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 80));
          idle(() => {
            console.time('[CartDrawer] idle hooks');
            if (typeof reInitCartSwiper === 'function') reInitCartSwiper('drawer-refresh');
            if (typeof guardDrawerQuickAddButtons === 'function') guardDrawerQuickAddButtons();
            if (typeof rebindCartDrawerAccordions === 'function') rebindCartDrawerAccordions();

            console.timeEnd('[CartDrawer] idle hooks');
          });
        } else {
          // 🧩 main-cart-items flow (non-drawer)
          const sourceQty = html.querySelector('cart-items');
          if (sourceQty) this.innerHTML = sourceQty.innerHTML;
          if (typeof window.applyInventoryGuards === 'function')
            window.applyInventoryGuards(document);
        }
      })
      .catch(console.error);
  }


  getSectionsToRender() {
    const sections = [];
    // Main cart page pieces (only if present)
    const mainItemsEl  = document.getElementById('main-cart-items');
    const mainFooterEl = document.getElementById('main-cart-footer');
    if (mainItemsEl?.dataset?.id) {
      sections.push({ id: 'main-cart-items', section: mainItemsEl.dataset.id, selector: '.js-contents' });
    }
    if (mainFooterEl?.dataset?.id) {
      sections.push({ id: 'main-cart-footer', section: mainFooterEl.dataset.id, selector: '.js-contents' });
    }

    // Always-safe globals
    sections.push(
      { id: 'cart-icon-bubble',     section: 'cart-icon-bubble',     selector: '#cart-icon-bubble' },
      { id: 'cart-live-region-text',section: 'cart-live-region-text',selector: '.shopify-section' },
      { id: 'cart-drawer',          section: 'cart-drawer',          selector: '.shopify-section' },
    );

    return sections;
  }


  /* ==========================================================
    🧩 updateQuantity with debounced refresh coalescing
    ========================================================== */
  updateQuantity(line, quantity, event, name, variantId) {

  //trace('UQ:START', { line, quantity, eventType: event?.type }, 'updateQuantity');
  if (window.CART_TRACE_UPDATES) {
  //console.log(`[TRACE updateQuantity] line=${line} qty=${quantity}`, {
   // eventType: event?.type,
   // requestInFlight: window.cartUpdateInflight,
   // time: performance.now()
  //});
}
  if (window.cartUpdateInflight) {
    return;
  }
  window.cartUpdateInflight = true;
  toggleCheckoutDisabled(true, 'Updating…');
  this.enableLoading(line);
  const body = JSON.stringify({
    line,
    quantity,
    sections: this.getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname,
  });
  const eventTarget = event?.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
    .then((response) => {
      return response.text();
    })
    .then(async (state) => {
      let parsedState = null;
      try {
        parsedState = JSON.parse(state);
      } catch (err) {
        console.warn('[cart.js] JSON parse failed, queueing debounced refresh instead');
        window.debouncedRefreshCartSections(); 
        return;
      }
      if (!parsedState) {
        this.disableLoading(line);
        return;
      }
      CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        // Empty-state toggles
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        // --- SECTION PATCHES ---
        const parser = window.__sharedDOMParser || (window.__sharedDOMParser = new DOMParser());
        this.getSectionsToRender().forEach((section) => {
          const target = document.getElementById(section.id);
          if (!target) {
            console.warn(`[cart.js] Target #${section.id} not found`);
            return;
          }
          const html = parsedState.sections[section.section];
          if (!html) return;
          if (window.CART_TRACE_UPDATES) {
          }
          const tempDoc = parser.parseFromString(html, 'text/html'); // ✅ reused DOMParser

          try {
            const rewardIds = Array.from(
              document.querySelectorAll('.milestone-detail[data-variant-id]')
            )
              .map(el => parseInt(el.dataset.variantId, 10))
              .filter(id => !isNaN(id) && id > 0);

            if (rewardIds.length) {
              rewardIds.forEach(id => {
                const lineEl = tempDoc.querySelector(`tr[data-variant-id="${id}"]`);
                if (!lineEl) return;
                lineEl.classList.add('gwp-line');
                const details = lineEl.querySelector('.cart-item__details');
                if (details && !details.querySelector('.gwp-notice')) {
                  const tag = tempDoc.createElement('span');
                  tag.className = 'gwp-notice micro-text';
                  tag.textContent = '1 Per Order';
                  const qtyBlock = details.querySelector('.cart-item__quantity');
                  if (qtyBlock) details.insertBefore(tag, qtyBlock);
                  else details.appendChild(tag);
                }
              });
            }
          } catch (err) {
            console.warn('[cart.js] GWP pre-inject failed', err);
          }
         
          const newHTML = tempDoc.querySelector(section.selector)?.innerHTML || '';
          const elementToReplace = target.querySelector(section.selector) || target;
          elementToReplace.innerHTML = newHTML;

        });

        // --- END PATCH ---

        try {
          const liveEl =
            document.getElementById(`Quantity-${line}`) ||
            document.getElementById(`Drawer-quantity-${line}`);
          if (liveEl) liveEl.setAttribute('value', String(liveEl.value));
        } catch (_) {}

        // Accessibility feedback
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = '';
        if (items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement?.value || 'NaN', 10)) {
          message = typeof updatedValue === 'undefined'
            ? window.cartStrings.error
            : window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
        this.updateLiveRegions(line, message);

        // Focus management
        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        const fallbackTarget = document.querySelector('.cart-item__name');
        try {
          if (lineItem && lineItem.querySelector?.(`[name="${name}"]`)) {
            const input = lineItem.querySelector(`[name="${name}"]`);
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, input) : input.focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            const emptyWrapper = cartDrawerWrapper.querySelector('.drawer__inner-empty');
            const emptyLink = emptyWrapper ? emptyWrapper.querySelector('a') : null;
            if (emptyWrapper && emptyLink) trapFocus(emptyWrapper, emptyLink);
          } else if (fallbackTarget && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, fallbackTarget);
          }
        } catch (trapErr) {
          console.error('[cart.js] trapFocus failed:', trapErr);
        }

        // Post-render hooks
        runPostRenderHooks(parsedState, 'updateQuantity');
        // Publish cart update
        try {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items',
            cartData: parsedState,
            variantId,
          });
        } catch (err) {
          console.warn('[cart.js] publish failed', err);
        }
      });

      CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);
    })
    .catch((err) => {
      window.debouncedRefreshCartSections();

    })
    .finally(() => {
      this.disableLoading(line);
      window.cartUpdateInflight = false;
      toggleCheckoutDisabled(false);
      rebindCartDrawerAccordions();
    });
}



  updateLiveRegions(line, message) {
    const lineItemError =
    document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
    const cartStatus =
    document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
    setTimeout(() => { cartStatus.setAttribute('aria-hidden', true); }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }


}

/* ==========================================================
   🧠 CART REFRESH DEBOUNCER — ensures redundant reloads collapse
   ========================================================== */
if (!window.debouncedRefreshCartSections) {
  const debounce = (fn, delay = 300) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  };

  window.debouncedRefreshCartSections = debounce(async () => {
    try {
      await refreshCartSections();
    } catch (err) {
      console.warn('[cart.js] debounced refresh failed', err);
    }
  }, 300);
}


/* ---------- Drawer-scoped Swiper init ---------- */
window.reInitCartSwiper = function reInitCartSwiper(source = 'unknown') {
  if (!window.__UPSellsEnabled__) return;
  const el =
    document.querySelector('#CartDrawer .cart-view') ||
    document.querySelector('cart-drawer .cart-view');
  if (!el) return;
  if (typeof window.Swiper !== 'function') {
    console.error('[swiper]', 'Swiper missing (from', source, ')');
    return;
  }
  const wrapper = el.querySelector('.swiper-wrapper');
  const slides  = el.querySelectorAll('.swiper-slide');
  if (!wrapper || slides.length === 0) return;
  if (el.__swiper && !el.__swiper.destroyed && typeof el.__swiper.destroy === 'function') {
    try { el.__swiper.destroy(true, true); } catch (e) {}
  }
  let inst;
  try {
    inst = new Swiper(el, {
      slidesPerView: 3,
      spaceBetween: 5,
      autoplay: { delay: 6000, disableOnInteraction: false },
      observer: true,
      observeParents: true,
      breakpoints: {
        0: { slidesPerView: 2.5, spaceBetween: 5 },
        1200: { slidesPerView: 3, spaceBetween: 5 }
      }
    });
  } catch (err) {
    console.error('[swiper]', 'init failed:', err, 'from', source);
    return;
  }
  el.__swiper = inst;
  requestAnimationFrame(() => inst.update());
};


window.CartItems = CartItems;
if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);
window.dispatchEvent(new Event('CartItems:ready'));

if (!customElements.get('cart-note')) {
  customElements.define('cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}










// --- QUICK ADD → CART DRAWER (multi-target refresh) ---
(function () {
  if (window.__quickAddBound) return;
  window.__quickAddBound = true;
  document.addEventListener('submit', async (ev) => {
    const form = ev.target.closest('form[data-type="quick-add-form"]');
    if (!form) return;
    ev.preventDefault();
    const btn = form.querySelector('button[type="submit"] span');
    const originalText = btn ? btn.textContent : null;
    if (btn) btn.textContent = 'Adding…';
    const formData = new FormData(form);
    try {
      const res = await fetch(`/cart/add.js?ts=${Date.now()}`, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      if (!res.ok) throw new Error('Add to cart failed');
      const item = await res.json();
      const cart = await getCartJSON(true);
      await refreshDrawer(); // update drawer with latest

      const drawerEl = document.querySelector('.drawer.cart-transition.whitebg-lo');
      drawerEl?.classList.add('active');
      document.body.classList.add('overflow-hidden');

    } catch (err) {
      console.error('[QuickAdd] ❌ ERROR:', err);
    } finally {
      if (btn && originalText) btn.textContent = originalText;
    }
  });
})();

// --- PRODUCT PAGE ADD-TO-CART → CART DRAWER ---
(function () {
  if (window.__productAddBound) return;
  window.__productAddBound = true;

  document.addEventListener('submit', async (ev) => {
    const form = ev.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return; // only catch product forms

    ev.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    const label = btn?.querySelector('span');
    const prevText = label ? label.textContent : null;

    if (label) label.textContent = 'Adding…';
    btn?.classList.add('is-loading');
    btn?.setAttribute('disabled', 'disabled');

    try {
      // POST to Shopify cart API
      const formData = new FormData(form);
      const res = await fetch(`/cart/add.js?ts=${Date.now()}`, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData,
        credentials: 'same-origin'
      });

      if (!res.ok) throw await res.json();
      const item = await res.json();
      console.log('[ProductAdd] ✅ Added', item);

      // Refresh drawer contents
      await refreshDrawer();

      // Open the drawer
      const drawerEl = document.querySelector('cart-drawer');
      drawerEl?.classList.add('active');
      document.body.classList.add('overflow-hidden');

    } catch (err) {
      console.error('[ProductAdd] ❌ ERROR:', err);
      alert((err && err.description) || 'Could not add to cart.');
    } finally {
      if (label && prevText) label.textContent = prevText;
      btn?.classList.remove('is-loading');
      btn?.removeAttribute('disabled');
    }
  });
})();


// --- Shipping Protection Add On (DOM-fresh + cartUpdate aware) ---
(() => {
  const W = window;
  const root = () => document.getElementById('shipping-protection');
  if (!root()) return;

  const SP_VARIANT_ID     = (root().dataset.variantId || '').trim() || null;
  const SP_PRODUCT_HANDLE = (root().dataset.productHandle || '').trim() || null;
  let VARIANT_ID = null;

  const money = (cents) => {
    try {
      return Shopify.formatMoney(cents, (W.SHOP && W.SHOP.moneyFormat) || "${{amount}}");
    } catch {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (W.SHOP && W.SHOP.currency) || 'AUD'
      });
    }
  };

  const btn = () => root()?.querySelector('.sp-toggle');
  const priceEl = () => root()?.querySelector('[data-sp-price]');

  /* ---------- Variant Resolution ---------- */
  async function resolveVariantId() {
    if (VARIANT_ID) return VARIANT_ID;
    if (SP_VARIANT_ID) return (VARIANT_ID = String(SP_VARIANT_ID));

    if (SP_PRODUCT_HANDLE) {
      const res = await fetch(`/products/${encodeURIComponent(SP_PRODUCT_HANDLE)}.js`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Failed to load product JSON for SP (handle)');
      const p = await res.json();
      const v0 = p.variants?.[0];
      if (!v0) throw new Error('No variants found for SP product');
      VARIANT_ID = String(v0.id);
      if (priceEl()) priceEl().textContent = money(v0.price);
      return VARIANT_ID;
    }

    throw new Error('Shipping Protection requires data-variant-id or data-product-handle on #shipping-protection');
  }

  /* ---------- Cart Helpers ---------- */
  async function isInCart(variantId) {
    const cart = await getCartJSON(true);
    return !!cart.items.find(it => String(it.variant_id) === String(variantId));
  }

  /* ---------- Drawer Section Refresh ---------- */
  async function refreshSPCartSections() {
    const base = (W.routes && W.routes.cart_url) || '/cart';
    const html = await fetch(`${base}?section_id=cart-drawer`, {
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(r => r.text());

    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Update title text only
    const newTitle = doc.querySelector('.drawer__header h2');
    const curTitle = document.querySelector('.drawer__header h2');
    if (newTitle && curTitle) curTitle.innerHTML = newTitle.innerHTML;

    // Update banner safely (replace content not node)
    const newBanner = doc.querySelector('.drawer__header .drawer-banner');
    const curBanner = document.querySelector('.drawer__header .drawer-banner');
    if (newBanner && curBanner) {
      curBanner.innerHTML = newBanner.innerHTML;
    } else if (newBanner && !curBanner) {
      document.querySelector('.drawer__header')?.insertBefore(newBanner, curTitle?.nextSibling || null);
    }

    // Replace line items
    const itemsNew = doc.querySelector('cart-drawer-items');
    const itemsCur = document.querySelector('cart-drawer-items');
    if (itemsNew && itemsCur) itemsCur.replaceWith(itemsNew);

    // Update checkout subtotal only (keeps milestones intact)
    const newPrice = doc.querySelector('.cart__checkout-button .price');
    const curPrice = document.querySelector('.cart__checkout-button .price');
    if (newPrice && curPrice) curPrice.textContent = newPrice.textContent;

    if (typeof W.applyInventoryGuards === 'function') W.applyInventoryGuards(document);
    if (typeof W.reInitCartSwiper === 'function') W.reInitCartSwiper('sp-toggle');

    reattach();
  }
  window.refreshSPCartSections = refreshSPCartSections;

  
  /* ---------- Toggle Logic ---------- */
  async function addSP() {
    const vid = await resolveVariantId();
    const r = await fetch(`/cart/add.js?ts=${Date.now()}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: vid, quantity: 1 })
    });
    if (!r.ok) throw await r.json().catch(() => new Error('Add failed'));
    return r.json();
  }

  async function removeSP() {
    const vid = await resolveVariantId();
    const r = await fetch(`/cart/update.js?ts=${Date.now()}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: { [vid]: 0 } })
    });
    if (!r.ok) throw await r.json().catch(() => new Error('Remove failed'));
    return r.json();
  }

  function setPressed(on) {
    const b = btn();
    if (!b) return;
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    const t = b.querySelector('.sp-toggle-text');
    if (t) t.textContent = on ? 'ON' : 'OFF';
    b.disabled = false;
    b.classList.remove('is-disabled');
  }

  let busy = false;
  async function onToggle() {
    if (busy) return;
    const b = btn();
    if (!b) return;
    busy = true;
    b.disabled = true;

    const wantOn = b.getAttribute('aria-pressed') !== 'true';
    try {
      if (wantOn) await addSP(); else await removeSP();
      setPressed(wantOn);
      await refreshSPCartSections();

      const vid = await resolveVariantId();
      setPressed(await isInCart(vid));
    } catch (err) {
      //console.error('[SP] Toggle failed', err);
      setPressed(!wantOn);
    } finally {
      const b2 = btn(); // fresh ref after refresh
      if (b2) b2.disabled = false;
      busy = false;
    }
  }

  /* ---------- Binding & Init ---------- */
  function reattach() {
    const b = btn();
    if (!b || b.__spBound) return;
    b.addEventListener('click', onToggle);
    b.__spBound = true;
  }

  async function init() {
    try {
      await resolveVariantId();
      const vid = await resolveVariantId();
      setPressed(await isInCart(vid));
      root().hidden = false;
    } catch (err) {
      //console.error('[SP] init failed', err);
      root().hidden = true;
    }
    reattach();
  }

  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, async () => {
      try {
        reattach();
        const vid = await resolveVariantId();
        setPressed(await isInCart(vid));
      } catch (_) {}
    });
  }

  const mo = new MutationObserver(() => reattach());
  mo.observe(document, { subtree: true, childList: true });

  init();
})();

// --- 🧩 Sync Shipping Protection toggle state on drawer refresh ---
function syncShippingProtectionToggle() {
  try {
    const spEl = document.getElementById('shipping-protection');
    if (!spEl) return;

    const vid = spEl.dataset.variantId || null;
    if (!vid) return;

    const btn = spEl.querySelector('.sp-toggle');
    const label = btn?.querySelector('.sp-toggle-text');
    if (!btn) return;

    getCartJSON(true).then(cart => {
      const hasSP = cart.items.some(it => String(it.variant_id) === String(vid));
      btn.setAttribute('aria-pressed', hasSP ? 'true' : 'false');
      btn.classList.remove('is-disabled');
      if (label) label.textContent = hasSP ? 'ON' : 'OFF';
      console.log('[SP] Toggle sync after cart update →', hasSP ? 'ON' : 'OFF');
    });
  } catch (err) {
    console.warn('[SP] Toggle sync failed', err);
  }
}


}